import { Button } from '@/components/ui/button'
import { FileText, Download } from 'lucide-react'
import { useId } from 'react'

type Template = {
  id: string
  name: string
  file_url: string | null
}

type Props = {
  title: string
  templates: Template[]
}

export function TemplateList({ title, templates }: Props) {
  const headingId = useId()

  return (
    <section className="rounded-lg border" aria-labelledby={headingId}>
      <div className="px-4 py-3 border-b">
        <h2 id={headingId} className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">{title}</h2>
      </div>
      {templates.length === 0 ? (
        <div className="flex items-start gap-3 px-4 py-6">
          <FileText className="mt-0.5 size-4 shrink-0 text-muted-foreground" aria-hidden="true" />
          <div>
            <p className="text-sm font-medium text-foreground">No documents available yet</p>
            <p className="mt-1 text-sm text-muted-foreground">Corppy will post documents here when they are ready.</p>
          </div>
        </div>
      ) : (
        <div className="space-y-2 px-4 py-3">
          {templates.map((template) => (
            <div key={template.id} className="flex items-center justify-between gap-3">
              <div className="flex min-w-0 items-center gap-2">
                <FileText className="size-3.5 shrink-0 text-muted-foreground" aria-hidden="true" />
                <span className="truncate text-sm">{template.name}</span>
              </div>
              {template.file_url && (
                <Button asChild variant="ghost" size="icon" className="size-11 shrink-0">
                  <a
                    href={template.file_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={`Download ${template.name} (opens in a new tab)`}
                  >
                    <Download className="size-4" aria-hidden="true" />
                  </a>
                </Button>
              )}
            </div>
          ))}
        </div>
      )}
    </section>
  )
}
